import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import Card from 'components/inputs/Card';
import { MdClose } from 'react-icons/md';
import { Row, Col } from 'react-bootstrap';
import { Formik, Form } from 'formik';
import TextInput from 'components/inputs/Input';
import Button from 'components/inputs/Button';
import _ from 'lodash';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { CREATE_RFID_GROUP, UPDATE_RFID_GROUP } from 'actions/rfidGroup';
import { CREATE_STATUS_CODE, UPDATE_STATUS_CODE } from 'components/common/constant';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

const RfidGroupForm = (props) => {
  const { isEdit, onClose = _.noop(), onSuccess = _.noop() } = props;
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const rfidGroupDetail = useSelector((state) => state.rfidGroup.rfidGroupDetail);
  const isLoading = useSelector((state) => state.rfidGroup.isLoading);

  const addRfidGroup = useCallback((data) => {
    dispatch({
      type: CREATE_RFID_GROUP.REQUEST,
      payload: data,
      cb: (res) => {
        if (_.get(res, 'status') === CREATE_STATUS_CODE) {
          onSuccess();
          onClose();
        }
      },
    });
  }, []);

  const updateRfidGroup = useCallback((data) => {
    dispatch({
      type: UPDATE_RFID_GROUP.REQUEST,
      payload: data,
      cb: (res) => {
        if (_.get(res, 'status') === UPDATE_STATUS_CODE) {
          onClose();
        }
      },
    });
  }, []);

  const RfidGroupSchema = Yup.object().shape({
    name: Yup.string().required(t('rfidGroupForm.name')).strict(true).trim(t('rfidGroupForm.space')).max(100, t('rfidGroupForm.maxlimit')),
    cashback_percent: Yup.number().required(t('rfidGroupForm.cashbackPercent')).min(0, t('rfidGroupForm.numchk')),
  });

  const initialValues = isEdit
    ? {
        ...rfidGroupDetail,
        offer_expiry_date: rfidGroupDetail.offer_expiry_date ? moment(rfidGroupDetail.offer_expiry_date).format('YYYY-MM-DD') : '',
      }
    : {
        name: '',
        cashback_percent: '',
        offer_expiry_date: '',
      };

  return (
    <React.Fragment>
      <div className="group-form-page__main">
        <Card>
          <div className="group-form-header__block">
            <div className="group-header-name">
              <span>
                {isEdit ? 'Edit' : 'Add'} {t('rfidGroupForm.title')}
              </span>
            </div>
            <div className="close___btn">
              <MdClose size={30} color="#BE210B" onClick={onClose} />
            </div>
          </div>
          <div className="group-form-body__block">
            <div className="group-form--block">
              <Formik
                enableReinitialize={!!isEdit}
                initialValues={initialValues}
                validationSchema={RfidGroupSchema}
                onSubmit={(values, { setSubmitting }) => {
                  if (isEdit) {
                    const editGroupData = _.omit(values, ['tenant', 'number_of_cards']);
                    updateRfidGroup(editGroupData);
                  } else {
                    addRfidGroup(values);
                  }
                  setSubmitting(false);
                }}
              >
                {({ values, errors, touched, handleSubmit, handleChange, isSubmitting }) => (
                  <Form onSubmit={handleSubmit}>
                    <Row>
                      <Col xl={6}>
                        <TextInput
                          isRequired
                          label={t('rfidGroupForm.groupName')}
                          placeholder={t('rfidGroupForm.groupName')}
                          name="name"
                          value={_.get(values, 'name', '')}
                          onChange={handleChange}
                          error={errors.name && touched.name ? errors.name : null}
                        />
                      </Col>
                      <Col xl={6}>
                        <TextInput
                          isRequired
                          label={t('rfidGroupForm.cashbackOffer')}
                          type="number"
                          placeholder={t('rfidGroupForm.cashbackOffer')}
                          name="cashback_percent"
                          value={_.get(values, 'cashback_percent', '')}
                          onChange={handleChange}
                          error={errors.cashback_percent && touched.cashback_percent ? errors.cashback_percent : null}
                        />
                      </Col>
                      <Col xl={6}>
                        <TextInput
                          label={t('rfidGroupForm.offerExpiryDate')}
                          placeholder={t('rfidGroupForm.offerExpiryDate')}
                          type="date"
                          name="offer_expiry_date"
                          value={values.offer_expiry_date}
                          onChange={handleChange}
                        />
                      </Col>
                    </Row>
                    <div className="form-btn__block">
                      <Button type="submit" disabled={isSubmitting || isLoading} className="form_btn">
                        {t('button.submitContinue')}
                      </Button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </Card>
      </div>
    </React.Fragment>
  );
};
RfidGroupForm.propTypes = {
  onSuccess: PropTypes.func,
  onClose: PropTypes.func,
  isEdit: PropTypes.bool,
};
export default RfidGroupForm;
